import { inject, Injectable } from '@angular/core';
import { BasisAccessService } from '@zaoblako/web/core/models/enums/access-rules/basis/basis-access.service';
import { BrsAccessService } from '@zaoblako/web/core/models/enums/access-rules/brs/brs-access.service';
import { CctvAccessService } from '@zaoblako/web/core/models/enums/access-rules/cctv/cctv-access.service';
import { DebtsAccessService } from '@zaoblako/web/core/models/enums/access-rules/debts/debts-access.service';
import { FdoAccessService } from '@zaoblako/web/core/models/enums/access-rules/fdo/fdo-access.service';
import { FinanceAccessService } from '@zaoblako/web/core/models/enums/access-rules/finance/finance-access.service';
import { HelpdeskAccessService } from '@zaoblako/web/core/models/enums/access-rules/helpdesk/helpdesk-access.service';
import { ManualAccessService } from '@zaoblako/web/core/models/enums/access-rules/manual/manual-access.service';
import { PacsAccessService } from '@zaoblako/web/core/models/enums/access-rules/pacs/pacs-access.service';
import { ProjectAccessService } from '@zaoblako/web/core/models/enums/access-rules/project/project-access.service';
import { TrafficAccessService } from '@zaoblako/web/core/models/enums/access-rules/traffic/traffic-access.service';

@Injectable({ providedIn: 'root' })
export class AccessService {
  public readonly basis = inject(BasisAccessService);
  public readonly brs = inject(BrsAccessService);
  public readonly cctv = inject(CctvAccessService);
  public readonly debts = inject(DebtsAccessService);
  public readonly fdo = inject(FdoAccessService);
  public readonly finance = inject(FinanceAccessService);
  public readonly helpdesk = inject(HelpdeskAccessService);
  public readonly manual = inject(ManualAccessService);
  public readonly pacs = inject(PacsAccessService);
  public readonly project = inject(ProjectAccessService);
  public readonly traffic = inject(TrafficAccessService);

  public hasAccess(key: string): boolean {
    if (key.startsWith('BASIS_')) return this.basis.checkRule(key as any);
    if (key.startsWith('BRS_')) return this.brs.checkRule(key as any);
    if (key.startsWith('CCTV_')) return this.cctv.checkRule(key as any);
    if (key.startsWith('DEBTS_')) return this.debts.checkRule(key as any);
    if (key.startsWith('FDO_')) return this.fdo.checkRule(key as any);
    if (key.startsWith('FINANCE_')) return this.finance.checkRule(key as any);
    if (key.startsWith('HELPDESK_')) return this.helpdesk.checkRule(key as any);
    if (key.startsWith('MANUAL_')) return this.manual.checkRule(key as any);
    if (key.startsWith('PACS_')) return this.pacs.checkRule(key as any);
    if (key.startsWith('PROJECT_')) return this.project.checkRule(key as any);
    return false;
  }
}
